import React from "react";

import {useGroup} from "~/contexts/group/GroupProvider";

import CreateGroupView from "./CreateGroupView";
import ManageGroupView from "./ManageGroupView";

const GroupContent: React.FC = () => {
  const {isCoopMode} = useGroup();

  if (isCoopMode) {
    return <ManageGroupView />;
  }

  return <CreateGroupView />;
};

export default GroupContent;
